'use strict';

var FiltersPanelDirective = function FiltersPanelDirective() {
  return {
    restrict: 'E',
    template: require('../templates/filters-panel.html'),
    controller: 'FiltersPanelController',
    scope: {
      brushFilterChanged: '=',
      screen: '@',
      getSelectedFlowType: '='
    }
  };
};
FiltersPanelDirective.$inject = [];
module.exports = FiltersPanelDirective;